import { IDeleteApplicationTemplateAssetsRequestBody } from '@kurtosys/types/api/applicationManager/IDeleteApplicationTemplateAssetsRequestBody.js';
import { IEndpointConfiguration } from '@kurtosys/types/api/common/IEndpointConfiguration.js';

import { KsysRequest } from '../KsysRequest.js';

export class DeleteApplicationTemplateAssets extends KsysRequest<IDeleteApplicationTemplateAssetsRequestBody, string> {
	getExplicitEndpoint = (): string => '/applicationManager/deleteApplicationTemplateAssets';
	get endpointConfiguration(): IEndpointConfiguration<any> {
		return this.getEndpointConfiguration('applicationManager', 'DeleteApplicationTemplateAssets');
	}
}
